export enum InvestmentMethodModalMode {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
